import request from '@/utils/request'

// 交付单列表
export function listDeliveryByPage(query) {
    return request({
        url: '/deliveryOrder/listByPage',
        method: 'post',
        data: query
    })
}

// 新增交付单
export function createDelivery(query) {
    return request({
        url: '/deliveryOrder/create',
        method: 'post',
        data: query
    })
}

// 交付单详情
export function queryDeliveryDetail(query) {
    return request({
        url: '/deliveryOrder/detail',
        method: 'get',
        params: query
    })
}

// 编辑项目信息
export function editProject(query) {
    return request({
        url: '/deliveryOrder/editProject',
        method: 'post',
        data: query
    })
}

// 编辑交付信息
export function editDelivery(query) {
    return request({
        url: '/deliveryOrder/editDelivery',
        method: 'post',
        data: query
    })
}

// 查询物流公司
export function logisticsCompanyList(query) {
    return request({
        url: '/common/logisticsCompanyList',
        method: 'post',
        data: query
    })
}

// 添加发货信息
export function express(query) {
    return request({
        url: '/deliveryOrder/express',
        method: 'post',
        data: query
    })
}

// 发货列表
export function expressList(query) {
  return request({
    url: '/deliveryOrder/expressList',
    method: 'post',
    data: query
  })
}

// 编辑发货信息
export function editExpress(query) {
    return request({
        url: '/deliveryOrder/editExpress',
        method: 'post',
        data: query
    })
}

// 删除发货信息
export function deleteExpress(id) {
  return request({
    url: '/deliveryOrder/deleteExpress/' + id,
    method: 'delete'
  })
}

// 确认交付
export function confirmDelivery(query) {
    return request({
        url: '/deliveryOrder/confirmDelivery',
        method: 'post',
        data: query
    })
}

// 服务单列表
export function listServiceByPage(query) {
    return request({
        url: '/serviceOrder/listByPage',
        method: 'post',
        data: query
    })
}

// 服务订单详情
export function queryServiceDetail(query) {
    return request({
        url: '/serviceOrder/detail',
        method: 'get',
        params: query
    })
}

// 创建服务单
export function createService(query) {
    return request({
        url: '/serviceOrder/create',
        method: 'post',
        data: query
    })
}

// 处理服务单
export function confirmDeal(query) {
    return request({
        url: '/serviceOrder/confirmDeal',
        method: 'post',
        data: query
    })
}

// 添加售后产品
export function saveAfterSaleProduct(query) {
    return request({
        url: '/serviceOrder/saveAfterSaleProduct',
        method: 'post',
        data: query
    })
}

// 编辑服务订单
export function editService(query) {
    return request({
        url: '/serviceOrder/edit',
        method: 'post',
        data: query
    })
}

// 删除服务单售后产品
export function deleteAfterSaleProduct(query) {
    return request({
        url: '/serviceOrder/deleteAfterSaleProduct',
        method: 'post',
        data: query
    })
}
